import styled from 'styled-components';
import { Drfq } from '@paradigm/features/src/unified-rfqs/entities/drfq/domain';

export function DrfqAccount({ drfq }: { drfq: Drfq | null | undefined }) {
  if (drfq?.account_name == null) return null;

  return (
    <AccountContainer>
      <Label>Account</Label>
      <span>{drfq.account_name}</span>
    </AccountContainer>
  );
}

const AccountContainer = styled.div`
  font-size: 12px;
  font-weight: bold;
`;

const Label = styled.div`
  opacity: 0.5;
  font-weight: normal;
`;
